module.exports = __webpack_public_path__ + "static/media/meter2.df4ff8b3.svg";